import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfRooftop extends AbstractProductType {

  name = 'self_rooftop'
  title = 'Self Rooftop'

  format = ProductTypeFormat.Rooftop

}
